import React from "react";
import { Button } from "../Button";
import HeroImage from "../../images/banner.png";
import "./styles.scss";
import { useButtonsActions } from "../../hooks/useButtonsActions";

interface HeroProps {}

function Hero({}: HeroProps) {
  const { handleNavigateToPages } = useButtonsActions();

  return (
    <section className="hero">
      <div>
        <div className="left">
          <h1 className="title">A Koin parcela o seu boleto</h1>
          <p className="paragraph1">
            Compre no site das lojas indicadas e gere um boleto à vista, envie
            seu boleto para a Koin e escolha em quantas vezes deseja pagar.
          </p>
          <Button id="lojasIndicadasHero" text="Ver Lojas Indicadas" onClick={handleNavigateToPages} />
        </div>
        <div className="right">
          <img src={HeroImage} alt="Hero Image" />
        </div>
      </div>
    </section>
  );
}

export { Hero };
